import React from 'react'
import FAQ from '../common/faq/FAQ'
import About_banner from './about-banner/About_banner'
import Making_payments from './making-payments/Making_payments'
import Why_we_exist from './why-we-exist/Why_we_exist'
import Who_We_Are from './who-we-are/Who_We_Are'

function About_us() {
    return (
        <>
            <About_banner />
            <Making_payments />
            <Why_we_exist />
            <Who_We_Are/>
            <FAQ />
        </>
    )
}

export default About_us